module.exports = __webpack_public_path__ + "resources/img/27017.6c9372408bb7d20dad6c5c29c1b7a416.png";